var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-action-status"},[_c('div',{staticClass:"product-list"},[_c('OrderSummary',{attrs:{"noback":"","noselect":"","input":_vm.input},on:{"continue":_vm.done}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }